module.exports = __webpack_public_path__ + "static/media/site-mobile.8a23e8b1.png";